import styled from 'styled-components';
import HBBox from '../HBBox/HBBox';
import { withStyles } from '../../styles/layout/withStyles';

export const GraphicWrapper = styled(withStyles(HBBox))`
    svg {
        width: 48px;
        height: 48px;
    }
`;
